import {
  COMMON_GET_PDF_BEGIN,
  COMMON_GET_PDF_SUCCESS,
  COMMON_GET_PDF_FAILURE,
  COMMON_GET_PDF_DISMISS_ERROR,
} from './constants';
import axios from 'axios'
import { PRESUPUESTADOR_ENDPOINT } from 'cfgCommon/endpoints'

export function getPdfCommon(id_presupuesto) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: COMMON_GET_PDF_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {

      const doRequest = axios(PRESUPUESTADOR_ENDPOINT+`/${id_presupuesto}/reports`,{
        method: 'GET',
        responseType: 'text/html'
      })
      doRequest.then(
        (res) => {
          dispatch({
            type: COMMON_GET_PDF_SUCCESS,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: COMMON_GET_PDF_FAILURE,
            data: { error: err.message },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetPdfError() {
  return {
    type: COMMON_GET_PDF_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_GET_PDF_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPdfPending: true,
        getPdfError: null,
      };

    case COMMON_GET_PDF_SUCCESS:
      // The request is success
      return {
        ...state,
        getPdfPending: false,
        getPdfError: null,
      };

    case COMMON_GET_PDF_FAILURE:
      // The request is failed
      return {
        ...state,
        getPdfPending: false,
        getPdfError: action.data.error,
      };

    case COMMON_GET_PDF_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPdfError: null,
      };

    default:
      return state;
  }
}
